// extracted by mini-css-extract-plugin
module.exports = {"btn":"LargeBtn_btn_1QgsH","isClicked":"LargeBtn_isClicked_1My0l","textNoWrap":"LargeBtn_textNoWrap_Z5Gwj"};